import { ALL_CATEGORIES, NEWS_ACF_BY_SLUG, ALL_NEWS_BY_SITENAME } from './queries/news'
import { SITENAME, STATIC_PAGE_WP_IDS, SLUGS } from '../utils/siteConfig'
import { sendNwReq, sendNwReqWithAuth } from './network'

/**
 * Get all news (Posts postype)
 * @returns {Array} Posts
 */
const getAllNews = async (preview = false) => {
  const response = preview
    ? await sendNwReqWithAuth(ALL_NEWS_BY_SITENAME, {
        siteName: [SITENAME],
        newsPageId: STATIC_PAGE_WP_IDS.news,
      })
    : await sendNwReq(ALL_NEWS_BY_SITENAME, {
        siteName: [SITENAME],
        newsPageId: STATIC_PAGE_WP_IDS.news,
      })

  const pageData = {
    allNewsPosts: response?.data?.posts?.nodes || [],
    seo: response?.data?.businessUnits?.seo || [],
    data: response?.data?.businessUnits?.signaturePageCommunity || [],
  }

  return pageData
}

// preview mode
const getAcfNewsBySlug = async slug => {
  if (!slug) return

  const variables = { slug: `${SLUGS.news}/${slug}` }

  const newsResp = await sendNwReqWithAuth(NEWS_ACF_BY_SLUG, variables)

  const news = newsResp?.data?.postBy || {}

  return news
}

/**
 * Get all Post categories
 * @returns {Object} Post Categories
 */
const getNewsCategories = async () => {
  const response = await sendNwReq(ALL_CATEGORIES)
  const terms = response?.data?.terms?.nodes || []
  const output = Object.fromEntries(terms.map(e => [e.slug, e.name]))

  return output
}

export { getAllNews, getAcfNewsBySlug, getNewsCategories }
